// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-actions[data-v-797fc40e]{border-top:.0625rem solid rgba(0,0,0,.12);display:flex;justify-content:space-between;padding:1.5rem}.dialog-actions__left[data-v-797fc40e],.dialog-actions__right[data-v-797fc40e]{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
